<template>
  <div class="childPannel">
    <div v-if="list.length" class="childPannel-box">
      <div v-for="m in list" @click="handleClickItem(m)" :key="m.id" class="childPannel-box-item">
        <div class="childPannel-box-item-block">
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">ID：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.id }}</span>
          </div>
          <span class="childPannel-box-item-block-info-label">沙洲名称：</span>
          <span class="childPannel-box-item-block-info-value">{{ m.name }}</span>
        </div>
      </div>
    </div>
    <el-empty v-if="!list.length" :image-size="100" description="当前内容为空" />
    <el-pagination
      class="childPannel-pagination"
      v-else
      size="small"
      v-model:current-page="params.pageNum"
      :page-size="params.pageSize"
      background
      :pager-count="5"
      @change="getList"
      layout="prev, pager, next"
      :total="total"
    />
  </div>
</template>

<script lang="ts" setup>
import { reactive, ref, watch } from 'vue'
import { toCameraPosition } from './utils'
import { LayerPopupCtrl } from '@/components/LayerPopupCtrl'
import { CesiumObj } from '@/components/GIS/CesiumObj'
import { Cartographic, Math } from 'cesium'
import SandbarPopup from '../../Popup/SandbarPopup.vue'
import { getsandbarList } from '@/apiFzn'
import type { IsandbarInfo } from '@/apiFzn/types'

const popupCtrl = LayerPopupCtrl.getInstance();
let cesiumobj: CesiumObj | null = null

const shipId = defineModel<string>('shipId')

const props = defineProps({
  showPannelKey: {
    type: String,
    default: '',
  },
  searchValue: {
    type: String,
    default: '', // 提供默认值
  },
})

const handleClickItem = async (m: IsandbarInfo) => {
  if (!cesiumobj) cesiumobj = await CesiumObj.getInstance()

  popupCtrl.popupMap.forEach((val) => {
    val.destroy()
  })
  toCameraPosition({
    lng: m.lon,
    lat: m.lat,
  })
  const cartographic = Cartographic.fromDegrees(m.lon, m.lat, 0)
  popupCtrl.popup({
    viewer: cesiumobj.viewer,
    id: m.id,
    lnglat: [cartographic.longitude, cartographic.latitude].map(Math.toDegrees) as [number, number],
    Com: SandbarPopup,
    properties: m,
  })
}

const params = reactive({
  pageNum: 1,
  pageSize: 8,
})
const list = ref<IsandbarInfo[]>([])
const total = ref(0)

const getList = () => {
  getsandbarList(params).then((res) => {
    list.value = res.rows
    total.value = res.total
  })
}

defineExpose({
  getList,
})

watch(
  () => props.searchValue,
  (newVal) => {
    // params.name = newVal // 将搜索值赋给查询参数
    // params.pageNum = 1 // 重置页码到第一页
  },
  { immediate: true } // 初始化时立即执行一次
)
</script>

<style lang="scss" scoped>
@import url('./childPannel.scss');
</style>
